"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgLargeClock = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 69 69", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.25 34.008c0-14.138 11.462-25.6 25.6-25.6 14.133.015 25.585 11.468 25.6 25.6 0 14.139-11.461 25.6-25.6 25.6-14.138 0-25.6-11.461-25.6-25.6zm33.68 11.27c.875.778 2.21.72 3.014-.132v.002a2.133 2.133 0 00-.141-3.016l-9.886-9.063V22.275a2.133 2.133 0 00-4.267 0v11.733c.003.6.257 1.17.7 1.572l10.58 9.699z", clipRule: "evenodd" })));
};
exports.default = SvgLargeClock;
//# sourceMappingURL=LargeClock.js.map